import { useTranslation } from "gatsby-plugin-react-i18next"
import { Button } from "primereact/button"
import { useCallback } from "react"
import formatCurrency from "utils/formatCurrency"
import { PaymentOptionsContainer } from "./styles"
import CurrencyInput from "./CurrencyInput"

const PaymentOptions = ({ onSelectCurrency, selectedAmount }) => {
  const { t } = useTranslation()
  const paymentAmounts = [5, 25, 50, 100, t('custom')]
  const currencies = [t('bgn')]
  const handleSelectCurrency = useCallback((n) => {
    onSelectCurrency(n)
  }, [onSelectCurrency])

  return (
    <PaymentOptionsContainer>
      {paymentAmounts.map((amount, i) => i === paymentAmounts.length - 1
        ? (
          <CurrencyInput key={amount} onSelectCurrency={handleSelectCurrency} currency={currencies[0]} />
        )
        : (
          <Button className={selectedAmount === amount ? 'p-button-outlined' : ''} key={amount} onClick={() => handleSelectCurrency(amount)}>
            {formatCurrency(amount)}{currencies[0]}
          </Button>
        ))}
    </PaymentOptionsContainer>
  )
}

export default PaymentOptions
